import { BusinessInfo } from "../../config";

const HelpModal = () => {
  return (
    <div
      className="modal fade"
      id="helpModal"
      tabIndex="-1"
      aria-labelledby="helpModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title" id="helpModalLabel">
              Contact & Support
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <p>
              <strong>Email:</strong> {BusinessInfo.email}
            </p>

            <p>
              <strong>Phone:</strong> {BusinessInfo.phone}
            </p>

            <hr />

            <h6>Follow Us</h6>

            <div className="d-flex flex-column gap-2">
              <a
                href={BusinessInfo.social.facebook}
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>

              <a
                href={BusinessInfo.social.instagram}
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>

              <a
                href={BusinessInfo.social.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HelpModal;
